import React, { useContext, useEffect, useState } from 'react';
import {
	MainImageVariant,
	MerchantIntegration,
	Product,
	WebsiteTaxonomy,
} from '@anticatrade/shared';
import { AppContext, appContext } from '../../../../context/AppContext';

const useWebsitePublish = (productID: number, merchantIntegrationID: number) => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [product, setProduct] = useState<Product | null>(null);
	const [integration, setIntegration] = useState<MerchantIntegration | null>(null);
	const [taxonomy, setTaxonomy] = useState<WebsiteTaxonomy | null>(null);

	const { api, handleError, merchant, redirect } = useContext(
		appContext as React.Context<AppContext>,
	);

	useEffect(() => {
		if (merchant == null) {
			return;
		}
		if (!merchant.features?.includes('integrations')) {
			redirect('products');
			return;
		}
		const load = async () => {
			try {
				const [productRes, integrationsRes, taxonomyRes] = await Promise.all([
					api.product(productID),
					api.merchantIntegrations(),
					api.merchantIntegrationTaxonomy(merchantIntegrationID),
				]);
				setProduct(productRes.product);
				setIntegration(
					integrationsRes.integrations.find((i) => i.id === merchantIntegrationID) ??
						null,
				);
				setTaxonomy(taxonomyRes.taxonomy);
			} catch (err) {
				handleError(err as Error);
			} finally {
				setIsLoading(false);
			}
		};
		load();
	}, [merchant]);

	const publish = async (
		websiteProduct: Record<string, unknown>,
		mainImageVariant: MainImageVariant,
	) => {
		return await api.publishToWebsite(
			merchantIntegrationID,
			productID,
			websiteProduct,
			mainImageVariant,
		);
	};

	return { isLoading, product, integration, taxonomy, publish };
};

export { useWebsitePublish };
